module.exports = __webpack_public_path__ + "assets/01ccc421f933026a569c41c7544e8741.png";